export default __webpack_public_path__ + "static/media/login_bg1.e144430d.png";